import { motion } from "framer-motion";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { useSite, wa } from "@/context/ContentContext";

export default function WhatsAppFloat() {
  const D = useSite();
  return (
    <motion.a
      data-testid="whatsapp-float-button"
      href={wa(D.site)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp'tan Bilgi Al"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="group fixed bottom-6 right-6 z-50 flex items-center md:bottom-8 md:right-8"
    >
      <span className="pointer-events-none absolute right-full mr-4 hidden whitespace-nowrap rounded-full border border-charcoal-900/5 bg-white/95 px-5 py-2.5 text-sm font-medium text-charcoal-900 opacity-0 shadow-lift backdrop-blur transition-all duration-500 ease-premium group-hover:-translate-x-1 group-hover:opacity-100 md:block">
        WhatsApp'tan Bilgi Al
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lift transition-transform duration-500 ease-premium group-hover:scale-105 md:h-16 md:w-16">
        <span aria-hidden="true" className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <WhatsAppIcon className="relative h-7 w-7" />
      </span>
    </motion.a>
  );
}
